import Cookies from 'universal-cookie';

import { history } from './history';

export const removeQuotes = text => text.replace(/['"]+/g, '');

export const getLastSegmentFromPath = path => path.split('/').pop();

// Converts a file to a Base64 string
export const convertBase64 = async file => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
            const remainder = encoded.length % 4;
            if (remainder) {
                encoded += '='.repeat(4 - remainder);
            }
            resolve(encoded);
        };
        reader.onerror = error => reject(error);
    });
};

const randomNumberGenerator = a => a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e16] + 1e16).replace(/[01]/g, randomNumberGenerator);

const getCsrfTokenValue = () => {
    const cookies = new Cookies();
    const currentCookie = cookies.get('X-CSRF-TOKEN');

    if (currentCookie) {
        return currentCookie;
    } else {
        const token = `CS${randomNumberGenerator()}`;
        cookies.set('X-CSRF-TOKEN', token, {
            path: '/',
            domain: '.testservicensw.net'
        });
        return token;
    }
};

const apiCall = async (method, url, data, overrideErrorHandling) => {
    const options = {
        method: method,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
            'X-CSRF-TOKEN': getCsrfTokenValue(),
            'x-api-key': process.env.REACT_APP_API_KEY
        }
    };

    const currentAuth = sessionStorage.getItem('AUTH')
    if (currentAuth) {
        options.headers['x-auth'] = currentAuth;
    }

    if (data) {
        options.body = JSON.stringify(data);
    }
    let response, text;

    try {
        response = await fetch(url, options);
        text = await response.text();
    }
    catch (err) {
        console.error('Error communicating with API', err, url, data);
        return null
    }


    let responseBody;

    try {
        responseBody = text ? JSON.parse(text) : null;
    }
    catch {
        // If not valid JSON, return the response which is most likely pure text
        responseBody = { content: text };
    }

    if (response.status < 200 || response.status >= 300) {
        sessionStorage.setItem('ErrorResponse', JSON.stringify(response));
        sessionStorage.setItem('ErrorResponseText', text);
        if (overrideErrorHandling) {
            responseBody._httpStatus = response.status;
        } else {
            history.push('/applicationError');
            window.dispatchEvent(new PopStateEvent('popstate'));
            throw responseBody;
        }
    }

    return responseBody;
};

export const apiPost = async (url, data, overrideErrorHandling) => {
    return await apiCall('POST', url, data, overrideErrorHandling);
};

export const apiGet = async (url, overrideErrorHandling) => {
    return await apiCall('GET', url, null, overrideErrorHandling);
};

export const apiPatch = async (url, data, overrideErrorHandling) => {
    return await apiCall('PATCH', url, data, overrideErrorHandling);
};

export const apiPut = async (url, data, overrideErrorHandling) => {
    return await apiCall('PUT', url, data, overrideErrorHandling);
};

export const apiDelete = async (url, data, overrideErrorHandling) => {
    return await apiCall('DELETE', url, data, overrideErrorHandling);
};
